// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IBlockData {
  typeId: string;
  state: { [name: string]: any };
}
